import { useMemo } from 'react';
import { IUseTableReturn } from '../useTable';

interface IUseMapKeyValueExtractorReturn<RowData> {
  keys: Array<string>;
  values: Array<RowData>;
}

const useMapKeyValueExtractor = <RowData extends object>(
  mapData: IUseTableReturn<RowData>['selectedRows'],
): IUseMapKeyValueExtractorReturn<RowData> => useMemo(() => {
    const keys = Array.from(mapData.keys());
    const values = Array.from(mapData.values());
    return { keys, values };
  }, [mapData]);

export default useMapKeyValueExtractor;
